<template>
  <section class="panel">
    <div class="fading">
      <h1 v-if="$route.name == 'summary'">Review your configuration</h1>
      <div class="text" v-html="text.review" v-if="$route.name == 'summary' && text"></div>
      <div class="review">
        <div class="review-left">
          <template v-if="personal && personal.name">
            <div class="review-heading" v-if="$route.name == 'summary'">Your details</div>
            <div class="review-heading" v-else>Personal details</div>
            <div class="row">
              <label class="label">Name</label>
              <input class="txt" disabled type="text" v-model="personal.name" />
            </div>
            <div class="row">
              <label class="label">Telephone</label>
              <input class="txt" disabled type="text" v-model="personal.telephone" />
            </div>
            <div class="row">
              <label class="label">Email</label>
              <input class="txt" disabled type="text" v-model="personal.email" />
            </div>
            <div class="row">
              <label class="label">Address</label>
              <input class="txt" disabled type="text" v-model="personal.address" />
            </div>
            <div class="row">
              <label class="label">Requirement</label>
              <input class="txt" disabled type="text" v-model="personal.type.label" />
            </div>
            <div class="row" v-if="personal.location">
              <label class="label">Churchyard / Cemetery</label>
              <input class="txt" disabled type="text" v-model="personal.location" />
            </div>
          </template>
          <template v-if="selectedExtras && selectedExtras.length">
            <div class="review-heading">Additional Items</div>
            <p>I would like more information regarding:</p>
            <div class="additions-grid">
              <div :key="i" class="addition" v-for="(extra, i) in selectedExtras">
                <img :alt="extra[1].name" :src="extra[1].image" />
                <span>{{ extra[0].name + " " + extra[1].name }}</span>
              </div>
            </div>
          </template>
          <div class="review-heading">Memorial Style</div>

          <template v-if="style.type == 'shape'">
            <div class="row">
              <label class="label">Shape</label>
              <input :value="style.shape.name" class="txt" disabled type="text" />
            </div>
            <div class="row">
              <label class="label">Size</label>
              <input :value="style.size" class="txt" disabled type="text" />
            </div>
            <div class="row">
              <label class="label">Colour</label>
              {{ style.colour.name }}
            </div>
            <div class="row">
              <div class="style colour">
                <img :alt="style.colour.name" :src="style.colour.image" class="style-image" />
              </div>
            </div>
          </template>

          <template v-if="style.type == 'catalogue'">
            <div class="row">
              <label class="label">Product</label>
              <input :value="style.product" class="txt" disabled type="text" />
            </div>
          </template>

          <div class="row" v-if="style.type == 'photo'">
            <div class="style colour">
              <img :src="style.photo" alt="Your photograph" class="style-image" />
            </div>
          </div>
        </div>
        <div class="review-right">
          <div class="review-heading">Memorial Inscription</div>
          <preview :inscription_text="inscription_text"></preview>
        </div>
      </div>

      <div class="actions" v-if="$route.name == 'summary'">
        <p v-if="error">{{ error }}</p>
        <button @click="$router.push('designer')" class="button back">Back</button>
        <button @click="finish" class="button">
          Continue
          <pulse></pulse>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import api from "@/services/api"
import Pulse from "@/components/Pulse.vue"
import Preview from "@/components/Preview.vue"

export default {
  data() {
    return { error: "" }
  },
  created() {
    if (this.$route.params.id) {
      api.lambda("get", "get?id=" + this.$route.params.id + "&site_id=" + this.$store.state.site_id).then(res => {
        this.$store.commit("setPersonal", res.personal)
        this.$store.commit("setStyle", res.style)
        this.$store.commit("setInscriptionText", res.inscription_text)
        this.$store.commit("setSelectedExtras", res.selectedExtras)
      })
    }
  },
  computed: {
    text() {
      return this.$store.state.text
    },
    personal() {
      return this.$store.state.personal
    },
    style() {
      return this.$store.state.style
    },
    inscription_text() {
      return this.$store.state.inscription_text
    },
    selectedExtras() {
      return this.$store.state.selectedExtras
    }
  },
  components: {
    Pulse,
    Preview
  },
  methods: {
    finish() {
      this.error = ""

      this.$router.push("/you")
    }
  }
}
</script>

<style scoped>
.text {
  max-width: 125rem;
  margin: auto;
}

.panel {
  text-align: center;
}

.review {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8rem;
  padding-bottom: 6rem;
  max-width: 125rem;
  margin: auto;
  text-align: left;
  font-size: 1.5rem;
  line-height: 1.2;
}

.review-heading {
  font-size: 2rem;
  font-family: "Roboto Slab", serif;
  color: #b1ba22;
  font-weight: bold;
  margin-top: 5rem;
  margin-bottom: 2rem;
}

.row {
  display: table;
  width: 100%;
  padding: 1rem 0;
}

.label {
  color: #b1ba22;
  width: 20%;
  max-width: 13rem;
  float: left;
}

.style-label span {
  color: #b1ba22;
  margin-right: 0.5rem;
}

.txt {
  font-size: 1.5rem;
  border: 0;
  background: transparent;
  color: #333;
  width: 80%;
}

.txt.full {
  width: 100%;
}

.txtarea {
  height: 4rem;
  resize: none;
}

.shape {
  width: 20rem;
}

.style {
  width: 45%;
  float: left;
}

.colour .style-image {
  border-radius: 1rem;
  margin-top: 1rem;
}

ul {
  padding-left: 2rem;
}

.additions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4rem;
}

@media screen and (max-width: 1050px) {
  .review {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 4rem;
  }
}
@media screen and (max-width: 550px) {
}
</style>
